<template>
  <div class="activedialog">
  <Debug></Debug>
  <b-breadcrumb>
    <b-breadcrumb-item href="#">
      <AllBusinessCasesUngrouped></AllBusinessCasesUngrouped>
    </b-breadcrumb-item>
    <b-breadcrumb-item @click="closeDialog()">
      <b-icon icon="people" scale="1.75" shift-v="1.25" aria-hidden="true"></b-icon>
      Offene Anfragen
    </b-breadcrumb-item>
    <b-breadcrumb-item active v-if="dialog">{{dialog.startTime | moment("DD. MMM YYYY - HH:mm")}} | {{dialog.channel}} | {{communicatingPerson}}</b-breadcrumb-item>
  </b-breadcrumb>

  <b-row>
    <b-col cols="4" >
      <DialogBox></DialogBox>
      <CustomerBox></CustomerBox>
    </b-col>

    <b-col cols="8">
      <b-card class="" border-variant="info">
        <b-icon icon="list-check" font-scale="3" class="float-right" variant="info"></b-icon>

        <b-tabs content-class="mt-3" v-model="tabIndex" ref="tabs">
          <b-tab title="ANLIEGEN">
            <DialogBusinessCases v-on:jumpToBC="jumpToBC"></DialogBusinessCases>
          </b-tab>
          <b-tab v-for="bc in activeBusinessCases" :title="bc.name" :key="bc.id" :ref="bc.id">
            <div class="vh-70 scroll">
              <BusinessCase v-bind:bc="bc"></BusinessCase>
            </div>
          </b-tab>
        </b-tabs>
      </b-card>
    </b-col>
  </b-row>


  </div>
</template>

<script>
import DialogBox from '@/components/DialogBox'
import CustomerBox from '@/components/CustomerBox'
import BusinessCase from '@/components/BusinessCase'
import DialogBusinessCases from '@/components/DialogBusinessCases'
import Debug from '@/components/Debug'
import AllBusinessCasesUngrouped from '@/components/AllBusinessCasesUngrouped'

export default {
  name: 'ActiveDialog',
  components: {
    DialogBox,
    CustomerBox,
    BusinessCase,
    DialogBusinessCases,
    Debug,
    AllBusinessCasesUngrouped
  },
  data() {
    return {
      tabIndex: 0
    }
  },
  methods: {
    setVariant() {
      if( this.businessCase ) {
        document.getElementById(this.businessCase.name).scrollIntoView({behavior: "smooth"});
        return 'warning';
      }
      else {
        return '';
      }
    },
    closeDialog() {
      this.$store.commit('updateDialog', '');
      this.$store.commit('updateDialogState', '');
      this.$store.dispatch('getDialogs');
    },
    jumpToBC(bc) {
      if( this.$refs[bc.id] && this.$refs[bc.id][0] )
        this.$refs[bc.id][0].activate();
    }
  },
  computed: {
    dialogState () {
      return this.$store.state.dialogState;
    },
    dialog () {
      return this.$store.state.dialog;
    },
    activeBusinessCases () {
      if( this.$store.state.dialogState && this.$store.state.dialogState.activeBusinessCases  ) {
        return this.$store.state.dialogState.activeBusinessCases
      }
      return null;
    },
    communicatingPerson () {
      if( this.$store.state.dialogState  &&
          this.$store.state.dialogState.slots &&
          this.$store.state.dialogState.slots.CommunicatingPerson &&
          this.$store.state.dialogState.slots.CommunicatingPerson.candidateValues &&
          this.$store.state.dialogState.slots.CommunicatingPerson.candidateValues[0])
      return this.$store.state.dialogState.slots.CommunicatingPerson.candidateValues[0].value.firstName + " " + this.$store.state.dialogState.slots.CommunicatingPerson.candidateValues[0].value.lastName;
      else
      return 'Unbekannt'
    }
  }
}
</script>

<style scoped>

</style>
